import { render, staticRenderFns } from "./IDSummary.vue?vue&type=template&id=9a780d30&scoped=true&lang=pug"
import script from "./IDSummary.vue?vue&type=script&lang=js"
export * from "./IDSummary.vue?vue&type=script&lang=js"
import style0 from "./IDSummary.vue?vue&type=style&index=0&id=9a780d30&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a780d30",
  null
  
)

export default component.exports